export const SAVVYY_TIME_ZONE = 'Africa/Dar_es_Salaam';

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const NAIVE_DATE_TIME_PATTERN = /^(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)$/;

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: SAVVYY_TIME_ZONE,
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: SAVVYY_TIME_ZONE,
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const normalizeTimestamp = (value) => {
  if (value instanceof Date || typeof value === 'number') return value;

  const rawValue = String(value).trim();
  if (DATE_ONLY_PATTERN.test(rawValue)) {
    return `${rawValue}T00:00:00+03:00`;
  }

  const naiveDateTime = rawValue.match(NAIVE_DATE_TIME_PATTERN);
  if (naiveDateTime) {
    return `${naiveDateTime[1]}T${naiveDateTime[2]}+03:00`;
  }

  return rawValue;
};

const partsMap = (formatter, date) => Object.fromEntries(
  formatter.formatToParts(date).map(({ type, value }) => [type, value]),
);

export const formatDateTimeEAT = (value, fallback = '-') => {
  if (value === null || value === undefined || value === '') return fallback;
  if (value === '-') return value;

  const rawValue = typeof value === 'string' ? value.trim() : value;
  const date = new Date(normalizeTimestamp(value));
  if (Number.isNaN(date.getTime())) return String(rawValue || fallback);

  const dateOnly = typeof rawValue === 'string' && DATE_ONLY_PATTERN.test(rawValue);
  const parts = partsMap(dateOnly ? dateFormatter : dateTimeFormatter, date);
  const formattedDate = `${parts.day} ${parts.month} ${parts.year}`;
  return dateOnly ? formattedDate : `${formattedDate}, ${parts.hour}:${parts.minute}`;
};
